import styled from 'styled-components';
import Button from '../button/Button';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

import ShopIcon from '../../assets/image/icon/shop.png'

const Wrapper = styled.div`
    padding: 7px 0 40px;

  .product-image {
    width: 100%;
    height: auto;
    margin: 20px 0;
  }
`;

const ShopCard = (props) => {
  return (
    <Wrapper>
        <ShopTitle name={props.name}/>
        <ShopLabels 
            label_dress={props.label_dress}
            label_original_item={props.label_original_item}
            label_cafe={props.label_cafe}
        />
        {props.time !== undefined && 
            <ShopInfo
                time={props.time}
                notice_time={props.notice_time}
                notice_dress={props.notice_dress}
                tel={props.tel}
                address1={props.address1}
                address2={props.address2}
                access={props.access}
            />
        }
        <ShopButtons 
            url={props.url}
            map_url={props.map_url}
            is_pc={props.is_pc}
        />
    </Wrapper>
  );
};

const ShopTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 22px;

    img {
        height: 11px;
        width: 12px;
    }

    h2 {
        font-size: 11px;
        margin-left: 7px;
    }
`;

const ShopTitle = (props) => {
    return (
        <FadeInFromBottom>
            <ShopTitleWrapper>
                <img src={ShopIcon} alt='ショップ'/>
                <h2>{props.name}</h2>
            </ShopTitleWrapper>
        </FadeInFromBottom>
    );
};

const ShopLabelsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 20px;
    padding-bottom: 20px;
    div{
        display: inline;
        color: #999899;
        font-size: 10px;
        border: 1px solid #ccc;
        padding: 6px 14px;
        margin: 0 9px 7px 0;
    }
`;

const ShopLabels = (props) => {
    return (
        <FadeInFromBottom>
            <ShopLabelsWrapper>
                {props.label_dress && 
                    <div>ドレス試着・購入OK</div>
                }
                {props.label_original_item && 
                    <div>オリジナルアイテム購入OK</div>
                }
                {props.label_cafe && 
                    <div>カフェとしてのご利用OK</div>
                }
            </ShopLabelsWrapper>
        </FadeInFromBottom>
    );
};

const ShopInfoWrapper = styled.div`
    font-size: 10px;
    margin-left: 20px;
    padding-bottom: 23px;
    line-height: 20px;
`;

const ShopInfo = (props) => {
    return (
        <FadeInFromBottom>
            <ShopInfoWrapper>
                {props.time &&
                    <p>営業時間：{props.time}</p>
                }
                {props.notice_time &&
                    <p>※営業時間は日によって異なる場合があります</p>
                }
                {props.notice_dress &&
                    <p>※ドレス試着の最終受付はお問い合わせください</p>
                }
                {props.tel &&
                    <p>電話番号：{props.tel}</p>
                }
                {props.address1 &&
                    <p>住所：{props.address1}</p>
                }
                {props.address2 &&
                    <p>{props.address2}</p>
                }
                {props.access &&
                    <p>アクセス：{props.access}</p>
                }
            </ShopInfoWrapper>
        </FadeInFromBottom>
    );
};

const ShopButtonsWrapper = styled.div`
    display: flex;
    justify-content: ${({ map_url }) => ( map_url ? 'space-between' : 'center')};
    width: ${({ pc }) => (pc ? '70%' : '88%')};
    margin: 0 auto;
`;

const ShopButtons = (props) => {
    return (
        <ShopButtonsWrapper pc={props.is_pc} map_url={props.map_url}>
            <Button 
                url={props.url}
                buttonText={"公式HP"}
            />
            {props.map_url &&
                <Button 
                    url={props.map_url}
                    buttonText={"Google Mapを開く"}
                />
            }
        </ShopButtonsWrapper>
    );
};
  
export default ShopCard;
  